import axios from 'axios';
import ps, {
  ProviderSearchActionTypes,
} from '@apps/shared/src/providerSearch/types/providerSearchActions';
import p, {
  GetPlans,
  GetMasterPlans,
  GetMasterPlansForCaseView,
} from '@apps/shared/src/planSelect/types/planActions';
import { Accessibility } from '@apps/shared/src/providerSearch/types/providerSearch';

export function getProviders(
  planID: string,
  selectedZipCode: string,
  selectedRadius: string,
  searchInput: string,
  limit: number,
  page: number,
  accessibilities: Accessibility[],
  providerType = '',
  providerSpeciality = '',
  gender = '',
  entityType = ''
): ProviderSearchActionTypes {
  const params = new URLSearchParams();

  params.append('zip', selectedZipCode);
  params.append('planID', planID);
  params.append('limit', limit.toString());
  params.append('page', page.toString());
  params.append('providerType', providerType);
  params.append('providerSpeciality', providerSpeciality);
  params.append('gender', gender);
  params.append('entityType', entityType);

  if (accessibilities && accessibilities.length > 0) {
    params.append('accessibilities', accessibilities.join(','));
  }

  if (searchInput && searchInput.trim()) {
    params.append('text', searchInput.trim());
  } else {
    params.append('radius', selectedRadius);
  }

  return {
    type: ps.GET_PROVIDERS,
    meta: {
      arg: { selectedZipCode, providerType },
    },
    payload: axios.get(`/api/provider-search/v1?${params.toString()}`, {
      headers: { 'X-CSRF-Token': localStorage.getItem('csrfToken') || '' },
    }),
  };
}
export function validateZipCode(selectedZipCode: string): ProviderSearchActionTypes {
  return {
    type: ps.VALIDATE_ZIP_CODE,
    meta: {
      arg: selectedZipCode,
    },
    payload: axios.get(`/api/zip-code-validation/v1/${selectedZipCode}`, {
      headers: { 'X-CSRF-Token': localStorage.getItem('csrfToken') },
    }),
  };
}

export function getPlans(): GetPlans {
  return {
    type: p.GET_PLANS,
    payload: axios.get(`/api/v2/get-plans`, {
      headers: { 'X-CSRF-Token': localStorage.getItem('csrfToken') },
    }),
  };
}

export function getAllPlansForMedivi(): GetPlans {
  return {
    type: p.GET_PLANS,
    payload: axios.get(`/api/v2/get-LivePlansForProviders`, {
      headers: { 'X-CSRF-Token': localStorage.getItem('csrfToken') },
    }),
  };
}

export function getMasterPlansForCaseView(): GetMasterPlansForCaseView {
  return {
    type: p.GET_MASTER_PLANS_CASE_VIEW,
    payload: axios.get(`/api/v2/masterPlans`, {
      headers: { 'X-CSRF-Token': localStorage.getItem('csrfToken') },
    }),
  };
}

export function getMasterPlans(): GetMasterPlans {
  return {
    type: p.GET_MASTER_PLANS,
    payload: axios.get(`/api/v2/get-masterPlans`, {
      headers: { 'X-CSRF-Token': localStorage.getItem('csrfToken') },
    }),
  };
}
